module.exports = __webpack_public_path__ + "static/media/Marker-Square.dc4ef677.jpg";